export default "__VITE_ASSET__DnB8Vvok__"